// tslint:disable-next-line:no-empty-interface
export interface BottomSheetData {}
